import React, { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { Button, Col, DatePicker, Form, Row, Select } from "antd";
import moment from "moment";
import Cookies from "universal-cookie";
import {
  exportTicketType,
  listBophanxuly,
  listLoaiyeucauAll,
} from "../constants";
import { authAxios } from "../utils";
import { openNotificationWithIcon } from "./Function";

const cookies = new Cookies();
const { RangePicker } = DatePicker;
const rangeConfig = {
  rules: [
    {
      type: "array",
      required: true,
      message: "Vui lòng chọn thời gian!",
    },
  ],
};

const validateMessages = {
  required: "Vui lòng nhập ${label}",
  types: {
    email: "${label} không đúng định dạng email!",
    number: "${label} không phải số!",
  },
  number: {
    range: "${label} must be between ${min} and ${max}",
  },
};

class TicketReport extends React.Component {
  state = {
    loading: false,
    showDetailData: false,
    detailData: [],
    lsBophan: [],
    loaiyeucau: [],
    currentYeuCau: "",
    fromdate: new Date(),
    todate: new Date(),
    dateNow: [moment(new Date()), moment(new Date())],
  };

  componentDidMount() {
    this.fetchListBpxl({
      columnSort: "id",
      typeSort: "ascend",
      is_active: true,
      page_size: "1000",
      page: "1",
    });
    // this.handleFetchUserInfo();
  }

  fetchListBpxl = (params = {}) => {
    this.setState({ loading: true });
    authAxios(cookies.get("token"))
      .get(listBophanxuly, { params: params })
      .then((res) => {
        var getLsBophan = res.data.results.filter(
          (item) => item.is_active == true,
        );
        var filter_lsBophan = Object.keys(
          this.props.handlingPermission,
        ).includes("AD")
          ? getLsBophan
          : getLsBophan.filter((d) => d.is_manager == this.props.infoUser[0]);
        if (filter_lsBophan.length != 0) {
          this.setState({
            lsBophan: filter_lsBophan,
            currentBophan: filter_lsBophan[0].name,
            defaultBophan: filter_lsBophan[0].id,
            loading: false,
          });
          this.handleChange_bophanxuly(filter_lsBophan[0].id);
        } else {
          this.setState({ loading: false });
        }
      })
      .catch((err) => {
        this.setState({ error: err, loading: false });
        if (err.response.status === 401) {
          this.props.history.push("/login");
        }
      });
  };

  handleChange_bophanxuly = (value) => {
    authAxios(cookies.get("token"))
      .get(listLoaiyeucauAll, {
        params: {
          handling_group: value,
          page_size: "1000",
          page: "1",
        },
      })
      .then((res) => {
        this.setState({
          loaiyeucau: res.data.results.filter((item) => item.is_active == true),
          defaultBophan: value,
          loading: false,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  fileDownload = (values) => {
    console.log(values);
    const fnFileDownload = require("js-file-download");
    const { dateNow } = this.state;
    let filename = "";

    if (values.assigned_loaiyeucau === "All") {
      filename =
        "Tat_ca_loai_yeu_cau_" +
        moment(new Date()).format("YYYYMMDD") +
        ".xlsx";
    } else {
      const currentBp = this.state.loaiyeucau.filter(
        (item) => item.id == values.assigned_loaiyeucau,
      )[0];
      filename =
        (currentBp ? currentBp.name : "Export") +
        "_" +
        moment(new Date()).format("YYYYMMDD") +
        ".xlsx";
    }

    var FormData = require("form-data");
    var data = new FormData();
    data.append("from_date", dateNow[0].format("YYYY-MM-DD")); //YYYY-MM-DD
    data.append("to_date", dateNow[1].format("YYYY-MM-DD"));
    data.append("ticket_type_id", values.assigned_loaiyeucau);
    data.append("bophanxuly_id", values.assigned_bophanxuly);
    authAxios(cookies.get("token"))
      .post(exportTicketType, data, { responseType: "blob" })
      .then((res) => {
        if (res.data.type === "application/json") {
          openNotificationWithIcon(
            "error",
            "Thông báo",
            "Loại yêu cầu này hiện không có dữ liệu",
          );
          return;
        }
        fnFileDownload(res.data, filename);
      });
  };

  isValidDate(d) {
    var r = /^(\d{4})\-(\d{1,2})\-(\d{1,2})$/; //YYYY-MM-DD
    return r.test(d) & !isNaN(new Date(d).getTime());
  }

  onFinish = (values) => {
    this.fileDownload(values);
  };

  formLayout = (data) => {
    const [form] = Form.useForm();

    useEffect(() => {
      var setDateFomate = [
        moment(data.dateNow[0]._d, "YYYY-MM-DD"),
        moment(data.dateNow[1]._d, "YYYY-MM-DD"),
      ];
      form.setFieldsValue({
        assigned_bophanxuly: data.defaultBophan,
        datepicker: setDateFomate,
      });
    }, [data]);

    const setCurrentBp = (value) => {
      this.handleChange_bophanxuly(value);
      form.setFieldsValue({
        assigned_loaiyeucau: "",
      });
      this.setState({ showDetailData: false });
    };
    const setRangeDate = (value) => {
      form.setFieldsValue({
        datepicker: [
          moment(value[0], "DD/MM/YYYY"),
          moment(value[1], "DD/MM/YYYY"),
        ],
      });
      this.setState({
        dateNow: [
          moment(value[0], "DD/MM/YYYY"),
          moment(value[1], "DD/MM/YYYY"),
        ],
      });
    };

    const getValue_IDLoaiyeucau = (value) => {
      this.setState({ showDetailData: true });
    };

    return (
      <Form
        onFinish={this.onFinish}
        form={form}
        style={{ textAlign: "center" }}
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        validateMessages={validateMessages}
      >
        <Row>
          <Col lg={{ span: 9, offset: 1 }}>
            <Row>
              <Col sm={24}>
                <Form.Item
                  label="Bộ phận xử lý"
                  name="assigned_bophanxuly"
                  rules={[{ required: true }]}
                >
                  {data.lsBophan.length === 1 ? (
                    <Select disabled placeholder="Chọn bộ phận xử lý">
                      {data.lsBophan.map((item, index) => (
                        <Select.Option key={index} value={item.id}>
                          {item.name}
                        </Select.Option>
                      ))}
                    </Select>
                  ) : (
                    <Select
                      placeholder="Chọn bộ phận xử lý"
                      loading={data.loading}
                      onChange={(value) => setCurrentBp(value)}
                    >
                      {data.lsBophan.map((item, index) => (
                        <Select.Option key={index} value={item.id}>
                          {item.name}
                        </Select.Option>
                      ))}
                    </Select>
                  )}
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col sm={24}>
                <Form.Item
                  label="Loại yêu cầu"
                  name="assigned_loaiyeucau"
                  rules={[{ required: true }]}
                  initialValue={[]}
                >
                  <Select
                    loading={data.loading}
                    placeholder="Chọn loại yêu cầu"
                    onChange={(value) => getValue_IDLoaiyeucau(value)}
                  >
                    {data.loaiyeucau.length > 0 && (
                      <Select.Option key="All" value="All">
                        Tất cả
                      </Select.Option>
                    )}
                    {data.loaiyeucau.map((v) => (
                      <Select.Option key={v.id} value={v.id}>
                        {v.name}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col sm={24}>
                <Form.Item
                  label={"Thời gian"}
                  name="datepicker"
                  {...rangeConfig}
                >
                  <RangePicker
                    ranges={{
                      "Hôm nay": [moment(), moment()],
                      "Tháng này": [
                        moment().startOf("month"),
                        moment().endOf("month"),
                      ],
                      "Năm nay": [
                        moment().startOf("year"),
                        moment().endOf("year"),
                      ],
                      "Năm ngoái": [
                        moment().add(-1, "year").startOf("year"),
                        moment().add(-1, "year").endOf("year"),
                      ],
                    }}
                    format="DD/MM/YYYY"
                    initialValues={[
                      moment(new Date(), "DD/MM/YYYY"),
                      moment(new Date(), "DD/MM/YYYY"),
                    ]}
                    onChange={(e, value) => setRangeDate(value)}
                    style={{ width: "100%" }}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <Col lg={{ span: 3, offset: 1 }} className="styleBtnExcel">
            <div className="brace-left">
              <div className="brace-top"></div>
              <div className="brace-bottom"></div>
            </div>
            <Row>
              <Form.Item>
                {/* <Button type={'primary'} >Tra cứu</Button> */}
                <Button
                  type={"danger"}
                  className={"btnGreen"}
                  htmlType={"submit"}
                >
                  Xuất excel
                </Button>
              </Form.Item>
            </Row>
          </Col>
        </Row>
      </Form>
    );
  };

  render() {
    return (
      <>
        <this.formLayout {...this.state} />
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {};
};
const mapStateToProps = (state) => {
  return {
    handlingPermission: state.user.handlingPermission,
    infoUser: state.user.infoUser,
  };
};
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(TicketReport),
);
